import ThumbUpIcon from '@mui/icons-material/ThumbUp'
import { Button, ButtonProps, Tooltip } from '@mui/material'
import { FC, useState } from 'react'

import FeedbackListDialog from './FeedbackListDialog'

const FeedbackListButton: FC<ButtonProps> = ({ ...props }) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)
  const handleClose = () => setDialogOpen(false)

  return (
    <>
      <FeedbackListDialog open={dialogOpen} handleClose={handleClose} />
      <Tooltip title="View list of customer reviews">
        <Button
          variant="text"
          color="primary"
          onClick={() => setDialogOpen(true)}
          data-testid="FeedbackListButton"
          startIcon={<ThumbUpIcon />}
          {...props}>
          View Reviews
        </Button>
      </Tooltip>
    </>
  )
}

export default FeedbackListButton
